import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ValidadorMinvuDto } from "../models/validadorMinvu";

const crearMinvuValidacion = async (data: ValidadorMinvuDto[]) => {
    const items = {
        items: data
    }
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-dividendos/v1/minvu/crear-minvu-validacion`, items);
    return response;
}

export { crearMinvuValidacion }